(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ConexionesDialogController', ConexionesDialogController);

    ConexionesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Conexiones'];

    function ConexionesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Conexiones) {
        var vm = this;

        vm.conexiones = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.conexiones.id !== null) {
                Conexiones.update(vm.conexiones, onSaveSuccess, onSaveError);
            } else {
                Conexiones.save(vm.conexiones, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:conexionesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.ultimafechaconexion = false;
        vm.datePickerOpenStatus.ultimafechatx = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
